/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const footer = css`
  background-color: #040404;
  color: #fff;
  margin-top: 50px;
`;

const Footer = () => {
  return (
    <footer css={footer}>
      <div className="container">
        <div
          className="row"
          css={css`
            height: 60px;
          `}
        >
          <div className="col-12 align-self-center">
            <p className="text-center m-0">
              {" "}
              Copyright &copy; Nikitin Pavel 2019
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
